const classApi = {
  GETCLASSLISTBYPAGER: 'CSVPA-China/api/classes/getListByPager', //班级列表
  GETCLASSBYCOURSEID: 'CSVPA-China/api/course/getClassByCourseId', //课程分类班级列表
  SAVECLASS: 'CSVPA-China/api/classes/save', //新增班级
  UPDATECLASS: 'CSVPA-China/api/classes/update', //编辑
  GETCLASSESDETAIL: 'CSVPA-China/api/classes/getClassesDetail', //班级详情
  GETLISTALLBYSTARTEDYEAR: 'CSVPA-China/api/classes/getListAllByStartedYear', //所有班级
  GETLISTBYUSERID: 'CSVPA-China/api/classes/getListByUserId', //老师班级
  SAVECLASSSTUDENT: 'CSVPA-China/api/roster/save', //编辑花名册
  ARCHIVECLASS: 'CSVPA-China/api/classes/archive', //班级归档
  UPGRADE: 'CSVPA-China/api/classes/upgrade' //班级升级
}

export default classApi
